<template>
  <div>
    <div class="goodsdetail">
      <particulars ref="detail"></particulars>

      <div
        class="orderNumber"
        v-if="
          gruopData.biddingStatus != 2 &&
          gruopData.biddingStatus != 3 &&
          gruopData.biddingStatus != 4 &&
          (gruopData?.lineType != 1 || ifShortEnterprise)
        ">
        <div
          class="order"
          v-if="enterpriseStatus != 7 && gruopData?.lineType != 1 && enterpriseStatus != 6">
          <el-button type="primary" class="join" v-if="enterpriseStatus == 2" @click="primaryClick"
            >参与竞价</el-button
          >
          <div v-if="enterpriseStatus == 4">
            <el-button type="primary" class="join" @click="unloaderClick">参与竞价</el-button>
          </div>

          <el-button
            type="primary"
            class="join"
            @click="auctionClick"
            v-if="enterpriseStatus != 2 && enterpriseStatus != 4"
            >参与竞价</el-button
          >
          <el-button
            class="collect"
            icon="el-icon-plus"
            @click="follow"
            v-if="gruopData.followFlag == 0"
            >收藏商品</el-button
          >
          <el-button
            class="collect"
            icon="el-icon-plus"
            @click="follows"
            v-if="gruopData.followFlag == 1"
            >取消收藏</el-button
          >

          <div
            style="margin-left: 20px"
            v-if="gruopData.distanceStartTime && gruopData.distanceStartTime != '0'">
            <div style="background-color: #f7f7f7">
              <div
                style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 9px;
                  font-size: 16px;
                  color: #333;
                ">
                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
                <div style="margin: 0 5px">距离开始还有</div>

                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
              </div>
              <CountDown
                v-if="gruopData.distanceStartTime"
                :endDate="`${gruopData.distanceStartTime}`"></CountDown>
            </div>
          </div>

          <div style="margin-left: 20px" v-if="gruopData.biddingStatus == 1">
            <div style="background-color: #f7f7f7">
              <div
                style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 9px;
                  font-size: 16px;
                  color: #333;
                ">
                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
                <div style="margin: 0 5px">距离结束还有</div>

                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
              </div>
              <CountDown
                v-if="gruopData.residueTime"
                :endDate="`${gruopData.residueTime}`"></CountDown>
            </div>
          </div>
        </div>

        <div
          class="form-box"
          v-if="
            ((enterpriseStatus == 6 || enterpriseStatus == 7) && gruopData?.lineType != 1) ||
            ifShortEnterprise
          ">
          <div class="form">
            <el-form :model="ruleForm" :rules="rules" ref="form" label-width="90px">
              <el-form-item
                label="报价金额"
                label-width="100px"
                prop="offerPrice"
                class="offerPrice">
                <i class="el-icon-minus" @click="sub"></i>
                <el-input
                  v-model="ruleForm.offerPrice"
                  maxlength="8"
                  @input="formatData('offerPrice')"
                  @blur="formatInput1('offerPrice')"></el-input>
                <i class="el-icon-plus" @click="add"></i>
                <span>元/吨</span>
                <el-button
                  type="primary"
                  @click="quotationClick"
                  v-if="enterpriseStatus == 7"
                  style="margin-left: 10px"
                  >立即报价</el-button
                >
                <el-button
                  type="primary"
                  @click="quotationClick"
                  v-if="enterpriseStatus == 6"
                  style="margin-left: 10px"
                  >支付保证金</el-button
                >
                <el-button
                  class="collect"
                  icon="el-icon-plus"
                  @click="follow"
                  v-if="gruopData.followFlag == 0"
                  >收藏商品</el-button
                >
                <el-button
                  class="collect"
                  icon="el-icon-plus"
                  @click="follows"
                  v-if="gruopData.followFlag == 1"
                  >取消收藏</el-button
                >
              </el-form-item>
            </el-form>

            <div v-if="gruopData.distanceStartTime && gruopData.distanceStartTime != '0'">
              <div style="background-color: #f7f7f7">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 9px;
                    font-size: 16px;
                    color: #333;
                  ">
                  <div
                    style="
                      width: 53px;
                      height: 1px;
                      background: #2a8de9;
                      display: inline-block;
                    "></div>
                  <div style="margin: 0 5px">距离开始还有</div>

                  <div
                    style="
                      width: 53px;
                      height: 1px;
                      background: #2a8de9;
                      display: inline-block;
                    "></div>
                </div>
                <CountDown
                  v-if="gruopData.distanceStartTime"
                  :endDate="`${gruopData.distanceStartTime}`"></CountDown>
              </div>
            </div>

            <div v-if="gruopData.biddingStatus == 1">
              <div style="background-color: #f7f7f7">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 9px;
                    font-size: 16px;
                    color: #333;
                  ">
                  <div
                    style="
                      width: 53px;
                      height: 1px;
                      background: #2a8de9;
                      display: inline-block;
                    "></div>
                  <div style="margin: 0 5px">距离结束还有</div>

                  <div
                    style="
                      width: 53px;
                      height: 1px;
                      background: #2a8de9;
                      display: inline-block;
                    "></div>
                </div>
                <CountDown
                  v-if="gruopData.residueTime"
                  :endDate="`${gruopData.residueTime}`"></CountDown>
              </div>
            </div>
          </div>
          <div class="lowestDiffPrice">最低降价{{ data.lowestDiffPrice }}元</div>
        </div>
      </div>
      <div v-if="gruopData?.lineType == 1 && !ifShortEnterprise">
        <div v-if="gruopData.distanceStartTime && gruopData.distanceStartTime != '0'">
          <div style="background-color: #f7f7f7; margin-top: 10px; padding: 10px 10px 20px 10px">
            <div
              style="
                display: flex;
                align-items: center;
                margin-bottom: 9px;
                font-size: 16px;
                color: #333;
              ">
              <div
                style="width: 53px; height: 1px; background: #2a8de9; display: inline-block"></div>
              <div style="margin: 0 5px">距离开始还有</div>

              <div
                style="width: 53px; height: 1px; background: #2a8de9; display: inline-block"></div>
            </div>
            <CountDown
              v-if="gruopData.distanceStartTime"
              :endDate="`${gruopData.distanceStartTime}`"></CountDown>
          </div>
        </div>

        <div v-if="gruopData.biddingStatus == 1">
          <div style="background-color: #f7f7f7; margin-top: 10px; padding: 10px 10px 20px 10px">
            <div
              style="
                display: flex;
                align-items: center;
                margin-bottom: 9px;
                font-size: 16px;
                color: #333;
              ">
              <div
                style="width: 53px; height: 1px; background: #2a8de9; display: inline-block"></div>
              <div style="margin: 0 5px">距离结束还有</div>

              <div
                style="width: 53px; height: 1px; background: #2a8de9; display: inline-block"></div>
            </div>
            <CountDown
              v-if="gruopData.residueTime"
              :endDate="`${gruopData.residueTime}`"></CountDown>
          </div>
        </div>
      </div>
      <div
        class="img_all"
        v-if="
          gruopData.biddingStatus != 2 &&
          gruopData.biddingStatus != 3 &&
          gruopData.biddingStatus != 4 &&
          gruopData?.lineType != 1
        ">
        <div>
          竞价资料:{{ gruopData.infoAuditStatus | infoAuditStatus }}
          {{
            gruopData.infoAuditStatus == 2 && gruopData.biddingStatus == 0
              ? "请等待竞价开始即可参与报价"
              : ""
          }}
        </div>
        <div v-if="gruopData.auditRefuseReason">拒绝理由：{{ gruopData.auditRefuseReason }}</div>
        <div v-for="(item, index) in fileInfos" :key="index" class="flex_item">
          <div v-for="(items, i) in item.fileInfos" :key="i">
            <div class="origin_item" @click="ItemClick(items)">
              {{ items.originalName }}
            </div>
          </div>
        </div>
      </div>
      <div class="company" v-if="computedLoginAndAuthentication">
        <div class="company_list" style="display: flex; justify-content: space-between">
          <div>竞价公司</div>
          <div style="cursor: pointer" @click="flushClick">
            <i class="el-icon-refresh"></i>
          </div>
        </div>
        <div class="company_table">
          <el-table :data="tableData" border>
            <el-table-column prop="companyName" align="center" label="竞价公司"> </el-table-column>
            <el-table-column prop="offerPrice" align="center" label="报价金额">
              <template slot-scope="scope">
                {{
                  scope.row.offerDetailList[0].offerPrice == 0
                    ? "*"
                    : scope.row.offerDetailList[0].offerPrice
                }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="offerCount"
              align="center"
              label="报价数量(吨)"
            >
            </el-table-column> -->
            <el-table-column prop="createTime" align="center" label="报价时间"> </el-table-column>
            <el-table-column prop="winBidding" align="center" label="中标状态">
              <template slot-scope="scope">
                <!-- {{ scope.row.winBidding | winBidding }} -->
                <div v-if="scope.row.winBidding == 1">
                  <img src="../../../assets/zxx_img/zhongbiao.png" alt="" />
                </div>
                <div v-if="scope.row.winBidding == 0">
                  <div>未中标</div>
                </div>
                <div v-if="scope.row.winBidding == '-1'">
                  <div>竞价中</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="details_bottom">
        <regulation class="regulation_bottom" :data="data"></regulation>
      </div>
    </div>
    <InputPasswordDialog
      :isShow="passWordIsShows"
      ref="InputPasswordDialog"
      title="请输入交易密码"
      @close="closeDialog('passWordIsShows')"
      @submit="submit" />
    <!-- 缴纳保证金弹窗 -->
    <PaymentBond
      :data="bonddialogoConfig"
      :isShow="bonddialogo"
      @close="closeDialog('bonddialogo')"
      @paymentSuccess="paymentSuccess()" />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisibleUpload" width="30%">
      <div>
        <div style="margin: 10px 0">{{ dialogCont }}</div>
        <el-upload
          class="upload-demo"
          action="#"
          :http-request="onSuccess"
          multiple
          :limit="10"
          :file-list="fileList"
          :accept="type == 2 ? '.jpg, .jpeg, .png' : '.jpg, .jpeg, .png,.PDF'">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            {{ type == 2 ? "(可上传JPG/JPEG/PNG格式文件)" : "(可上传JPG/JPEG/PNG/PDF格式文件)" }}
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleUpload = false">取 消</el-button>
        <el-button type="primary" @click="UploadClick">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="imgUrldialogVisible" width="30%">
      <div class="iamg_y">
        <!-- <img :src="imgUrl" alt="" /> -->
        <el-button
          @click="examinecontract(imgUrl)"
          v-if="(imgUrl && imgUrl.slice(-4) == '.pdf') || (imgUrl && imgUrl.slice(-4) == '.PDF')">
          点击查看PDF文件<br /><br /><br />{{ originalName }}</el-button
        >
        <el-image
          v-else
          style="width: 100px; height: 100px"
          :src="imgUrl"
          :preview-src-list="srcList">
        </el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgUrldialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="imgUrldialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      :close-on-press-escape="allFalse"
      :close-on-click-modal="allFalse"
      :show-close="allFalse"
      width="80%"
      center>
      <div class="width_center">
        <div class="go_0" @click="handleGoBack">
          <i class="hy-icon-fanhui" style="color: #4e6ef2; font-size: 18px"></i>
          返回
        </div>
        <div class="title">{{ inner.messageContent }}</div>
        <div class="data"><i class="hy-icon-shijian1"></i> {{ inner.createTime }}</div>
        <div class="img" v-if="inner.articleContent">
          <!-- <img
        style="width: 100%; height: 100%"
        :src="baseUrl+'third/third/ossGetFile/'+inner.messageImg"
      /> -->
          <div v-html="inner.articleContent" class="articlContet"></div>
          <div class="content_all">
            <div v-for="(item, index) in inner.fileList" :key="index">
              <!-- <el-button style="height:60px;line-height: 30px;" @click="examinecontract(item.storageName)">点击下载文件({{item.originalName}}) -->
              <div class="fileListImg">
                <img
                  src="../../../assets/img/pdf.png"
                  alt=""
                  v-if="
                    item.storageName.slice(-4) == '.pdf' || item.storageName.slice(-4) == '.PDF'
                  " />
                <img
                  src="../../../assets/img/word.png"
                  alt=""
                  v-if="
                    item.storageName.slice(-4) == '.doc' || item.storageName.slice(-5) == '.docx'
                  " />
                <a :href="baseUrl + 'third/third/ossGetFile/' + item.storageName" target="_blank">{{
                  item.originalName
                }}</a>
              </div>
              <!-- </el-button> -->
            </div>
          </div>
        </div>
        <div v-else-if="inner.messageImg" class="img">
          <img
            style="width: 100%; height: 100%"
            :src="baseUrl + 'third/third/ossGetFile/' + inner.messageImg" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div>
          <el-checkbox v-model="checked">我已阅读并接受以上竞价公告所示内容</el-checkbox>
        </div>
        <el-button class="subimt_btn" type="primary" @click="AddConfirm" :disabled="!checked"
          >参与竞价</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import particulars from "./particulars.vue";
import CountDown from "@/components/countDowns.vue";
import {
  tGroupDtetails,
  ossUploadFiletwo,
  checkIfConfirm,
  bidNoticeConfirm,
} from "@/api/public.js";
import { MessageBox } from "element-ui";
import { amountCalculation } from "@/api/public.js";
import {
  getEnterpriseStatus,
  uploadInformation,
  applyToBeService,
  getTbGoodsDetail,
  tradeOfferpage,
} from "@/api/Logistics.js";
import { biddingdetail } from "@/api/home";
import { formatDate } from "@/utils/date";
import { reqIsPayBonds, reqFollow, reqIsPayBond, reqAddBiddingOffer, reqPayBond } from "@/api/hy";
import * as types from "@/store/action-types";
import md5 from "js-md5";
import Vue from "vue";
import InputPasswordDialog from "./passwordInput.vue";
import { getAccountBalanceByParam } from "@/api/Accountopening";
import regulation from "./regulation.vue";
const { baseUrl } = require("@/config");
import { mapState, mapActions } from "vuex";
import PaymentBond from "./paymentBond.vue";
export default {
  components: {
    particulars,
    InputPasswordDialog,
    PaymentBond,
    regulation,
    CountDown,
  },
  name: "",
  data() {
    return {
      baseUrl: baseUrl,
      inner: {},
      checked: false,
      centerDialogVisible: false,
      allFalse: false,
      dialogTitle: "参与竞价资料上传",
      dialogCont: "请上传相关资料",
      gruopData: {},
      /** 支付保证金弹框 */
      bonddialogo: false,
      /** 支付保证金弹框数据(新) */
      bonddialogoConfig: {
        bondAmount: "",
        accountList: [],
      },
      ruleForm: {
        num: "",
        offerPrice: "",
      },
      rules: {
        num: [
          {
            required: true,
            message: "请输入可供应数量",
            trigger: "blur",
          },
        ],
        offerPrice: [
          {
            required: true,
            message: "请输入报价金额",
            trigger: "blur",
          },
        ],
      },
      /** 保证金金额 */
      bond: 0,
      srcList: [],
      imgUrldialogVisible: false,
      imgUrl: "",
      fileInfos: [],
      type: 1,
      fileList: [],
      dialogVisibleUpload: false,
      /** ddd状态状态  */
      enterpriseStatus: 0,
      enterMessge: "",
      data: {},

      /** 缴纳方式下拉框 */
      balances: [],
      passWordIsShows: false,
      dialogofflineForm: false,
      templateSelection: "",
      dialogVisible: false,
      dialogVisible1: false,
      pageData: [],
      num: "",
      TbaleList: [],
      gruopData: [],
      tableData: [],
      allPice: 0,

      fileL: [],
      storageName: "",
      originalName: "",
      // userId:''
    };
  },
  mounted() {
    this.getConfirm();
    this.getlisst();
    this.getNewlist();
    this.getstatus();
    this.getTbGoodsDetail();
    // this.userId=Vue.ls.get("userId")
  },
  computed: {
    ...mapState({
      massage: state => state.user.massage,
    }),
    ifShortEnterprise() {
      return this.gruopData?.lineType == 1 && this.gruopData?.ifShortEnterprise;
    },
    computedLoginAndAuthentication() {
      let status = this.massage == "未登录请前往登录" || this.massage == "请前往认证后操作";
      return !status;
    },
  },
  filters: {
    formatCreateTime(time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    winBidding(val) {
      let _data = {
        "-1": "竞价中",
        0: "未中标",
        1: "已中标",
      };
      return _data[val];
    },
    infoAuditStatus(val) {
      let _data = {
        0: "待审核",
        1: "管理后台审核已通过,请等待发布方审核",
        2: "审核通过",
        3: "审核拒绝",
      };
      return _data[val];
    },
  },
  methods: {
    handleGoBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/index"); // fallback 页面
      }
    },
    getinner(id) {
      biddingdetail({ messageId: id }).then(res => {
        if (res.code == 0) {
          this.inner = res.data;
          console.log(res.data);
          this.inner.createTime = res.data.createTime.replace("T", " ");
        }
      });
    },
    getConfirm() {
      let config = {
        goodsId: this.$route.query.goodsId,
      };
      checkIfConfirm(config).then(res => {
        console.log(res, "66666666666");
        if (res.code == 0) {
          if (res.data.ifConfirm == true) {
            this.centerDialogVisible = false;
          } else {
            this.getinner(res.data.messageId);
            this.centerDialogVisible = true;
          }
        }
      });
    },
    async AddConfirm() {
      let config = {
        goodsId: this.$route.query.goodsId,
      };
      bidNoticeConfirm(config).then(res => {
        if (res.code == 0) {
          this.centerDialogVisible = false;
        }
      });
    },
    examinecontract(item) {
      window.open(item);
    },
    async quotationClick() {
      if (!this.checkLoginAndAuth()) return;
      if (this.enterpriseStatus == 6) {
        await this.btnClick();
        // 确保bonddialogoConfig的值和 组件paymentBond的props中的data的值一致
        this.bonddialogoConfig.bondAmount = this.bond;
        this.bonddialogoConfig.accountList = this.balances;
        this.bonddialogo = true;
      }
      if (this.enterpriseStatus == 7) {
        if (this.ruleForm.offerPrice == "") {
          this.$message.error("请输入报价金额");
          return;
        }
        let config = {
          goodsId: this.$route.query.goodsId,
          offerDetailList: [
            {
              categoryId: this.data.categoryList[0].categoryId,
              offerCount: 0,
              offerPrice: this.ruleForm.offerPrice,
            },
          ],
        };
        reqAddBiddingOffer(config).then(res => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: "报价成功",
              type: "success",
            });
            this.getNewlist();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      }
    },

    sub() {
      let config = {
        dataList: [
          {
            num1: !isNaN(this.ruleForm.offerPrice) ? Number(this.ruleForm.offerPrice) : 0,
            num2: 1,
          },
          {
            num1: Number(this.data.lowestDiffPrice) * -1,
            num2: 1,
          },
        ],
      };
      amountCalculation(config).then(res => {
        this.ruleForm.offerPrice = Number(res.data) < 0 ? 0 : res.data;
      });
      // if (Number(this.ruleForm.offerPrice) == 0) {
      //   this.ruleForm.offerPrice = 0;
      // } else {
      //   this.ruleForm.offerPrice =
      //     Number(this.ruleForm.offerPrice) * 100 -
      //       Number(this.data.lowestDiffPrice) * 100 <
      //     0
      //       ? 0
      //       : (Number(this.ruleForm.offerPrice) * 100 -
      //           Number(this.data.lowestDiffPrice) * 100) /
      //         100;
      // }
    },
    add() {
      let config = {
        dataList: [
          {
            num1: !isNaN(this.ruleForm.offerPrice) ? Number(this.ruleForm.offerPrice) : 0,
            num2: 1,
          },
          {
            num1: Number(this.data.lowestDiffPrice),
            num2: 1,
          },
        ],
      };
      amountCalculation(config).then(res => {
        this.ruleForm.offerPrice =
          Number(res.data) > Number(this.data.floorPrice) ? this.data.floorPrice : res.data;
      });
      // this.ruleForm.offerPrice =
      //   (Number(this.ruleForm.offerPrice) * 100 +
      //     Number(this.data.lowestDiffPrice) * 100) /
      //   100;
    },
    ItemClick(e) {
      console.log(e);
      this.imgUrldialogVisible = true;
      this.originalName = e.originalName;
      this.imgUrl = this.baseUrl + "third/third/ossGetFile/" + e.storageName;
      this.srcList.push(this.baseUrl + "third/third/ossGetFile/" + e.storageName);
    },
    getTbGoodsDetail() {
      getTbGoodsDetail(this.$route.query.goodsId).then(res => {
        if (res.code == 0) {
          this.bond = res.data.bond;
          this.fileInfos = res.data.informationList;
          this.gruopData = res.data;
          this.data = res.data;
          this.ruleForm.offerPrice = this.data.floorPrice;
          console.log(this.data, "ldldldldldldl");
        }
      });
    },
    async primaryClick() {
      let id = Vue.ls.get("userId");
      if (!id) {
        this.$message.error("请登录账号");
        return false;
      }
      if (!this.checkLoginAndAuth()) return;

      this.dialogVisibleUpload = true;
      this.dialogTitle = "提示";
      this.dialogCont = "您当前企业类型非物流服务商,需上传道路运输许可证后,方可参与物流竞价!";
      this.type = 2;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    UploadClick() {
      if (this.type == 1) {
        let config = {
          fileIds: this.fileL,
          goodsId: this.$route.query.goodsId,
        };
        uploadInformation(config).then(res => {
          if (res.code == 0) {
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.getstatus();
            this.getTbGoodsDetail();
            this.dialogVisibleUpload = false;
          }
        });
      } else if (this.type == 2) {
        let config = {
          roadTransportLicenseUrl: this.storageName,
        };
        applyToBeService(config).then(res => {
          if (res.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleUpload = false;
            this.getstatus();
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      }
    },
    onSuccess(file) {
      // console.log(file,this.fileList)
      let otherFiles = file.file;
      var formData = new FormData();
      formData.append("file", otherFiles);
      ossUploadFiletwo(formData).then(res => {
        if (res.code == 0) {
          let list = [];
          this.storageName = res.data.storageName;
          list.push(res.data.fileId);
          var newArr = [...new Set(list)];
          this.fileL = newArr;
          this.$message({
            message: "上传成功",
            type: "success",
          });
          this.getstatus();
        }
      });
    },
    async unloaderClick() {
      let id = Vue.ls.get("userId");
      if (!id) {
        this.$message.error("请登录账号");
        return false;
      }
      if (!this.checkLoginAndAuth()) return;

      this.dialogVisibleUpload = true;
      this.type = 1;
    },
    /** 参与竞价前置校验：直接读 vuex 的 massage，同步判断"已登录 + 企业认证通过" */
    checkLoginAndAuth() {
      if (this.massage == "未登录请前往登录") {
        // 与全局 beforhandle 保持一致：仅 toast 提示，不弹框不跳转
        this.$message.error(this.massage);
        return false;
      }
      if (this.massage == "请前往认证后操作") {
        MessageBox.confirm("请前往认证后操作", "提示", {
          confirmButtonText: "交易会员认证",
          cancelButtonText: "中长期会员认证",
          type: "warning",
          customClass: "hy-confirm",
          iconClass: "el-icon-info",
          distinguishCancelAndClose: true,
        })
          .then(() => {
            this.$router.push("/authentication");
          })
          .catch(action => {
            // 仅点击"中长期会员认证"(cancel)时跳转，右上角关闭/ESC(close)不跳转
            if (action === "cancel") {
              this.$router.push("/MediumTerm");
            }
          });
        return false;
      }
      return true;
    },
    // 参与竞价（多重判断）
    async auctionClick() {
      let id = Vue.ls.get("userId");
      if (!id) {
        this.$message.error("请登录账号");
        return false;
      }
      if (!this.checkLoginAndAuth()) return;

      if (
        this.enterpriseStatus == 0 ||
        this.enterpriseStatus == 1 ||
        this.enterpriseStatus == 3 ||
        this.enterpriseStatus == 5
      ) {
        this.$message({
          message: this.enterMessge,
          type: "warning",
        });
      }
    },
    getstatus() {
      let id = this.$route.query.goodsId;
      getEnterpriseStatus(id).then(res => {
        if (res.code == 0) {
          this.enterpriseStatus = res.data.enterpriseStatus;
          this.enterMessge = res.data.message;
          console.log(res.data, "ssssssssssssssssss");
        }
      });
    },
    flushClick() {
      this.getNewlist();
    },
    //签合同
    goContract() {
      this.$router.push({
        path: "/order",
      });
    },
    btnClick() {
      let config = {
        searchType: 0,
      };
      return getAccountBalanceByParam(config).then(res => {
        if (res.code == 0) {
          console.log("getAccountBalanceByParam", res.data);
          this.balances = res.data;
          this.dialogofflineForm = true;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    paymentSuccess() {
      this.$message({
        message: "保证金已支付成功，请在竞价开始后进行报价。",
        type: "success",
      });
      this.bonddialogo = false;
      this.getstatus();
      this.getNewlist();
      setTimeout(() => {
        location.reload();
      }, 2000);
    },
    getreqIsPayBond() {
      this.btnClick();
    },
    submit(val) {
      let config = {
        bankType: this.offlineForm.bankType,
        goodsId: this.$route.query.goodsId,
        password: md5(val),
      };
      reqPayBond(config).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "保证金已支付成功，请在竞价开始后进行报价。",
            type: "success",
          });
          this.bonddialogo = false;
          this.getstatus();
          this.getNewlist();
          setTimeout(() => {
            location.reload();
          }, 2000);
          // let configs = {
          //   goodsId: this.$route.query.goodsId,
          //   offerDetailList: [
          //     {
          //       categoryId: this.data.categoryList[0].categoryId,
          //       offerCount: 0,
          //       offerPrice: this.ruleForm.offerPrice,
          //     },
          //   ],
          // };
          // reqAddBiddingOffer(configs).then((res) => {
          //   console.log(res);
          //   if (res.code == 0) {
          //     this.$message({
          //       message: "保证金已支付成功，请在竞价开始后进行报价。",
          //       type: "success",
          //     });
          //     location.reload();
          //     this.bonddialogo = false;
          //     this.getstatus();
          //     this.getNewlist();
          //     this.$route.go(-1);
          //   } else {
          //     this.$message({
          //       message: res.message,
          //       type: "error",
          //     });
          //   }
          // });
          // this.bonddialogo = false;
          // this.getstatus();
          // this.$message({
          //   message: res.data,
          //   type: "success",
          // });
          // this.$route.go(-1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closeDialog(tag) {
      this[tag] = false;
    },
    biddingOffer() {},
    openPayBond() {
      this.dialogVisible1 = false;
      let id = Vue.ls.get(types.enterpriseId);
      reqIsPayBonds(id).then(ret => {
        console.log(ret);
        if (ret.code == 0) {
          console.log(ret.data);
          if (ret.data) {
            this.getreqIsPayBond();
          } else {
            this.$confirm("暂无设置交易密码, 是前往设置?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push("/finance");
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          }
        } else {
          this.$message({
            type: "error",
            message: ret.message,
          });
        }
      });
    },
    toPay() {
      this.dialogVisible = false;
      this.dialogVisible1 = true;
    },

    formatInput1(key) {
      if (this.ruleForm[key].indexOf(".") == this.ruleForm[key].length - 1) {
        this.ruleForm[key] = this.ruleForm[key].slice(0, this.ruleForm[key].length - 1);
      }
    },
    formatData(key) {
      this.ruleForm[key] =
        this.ruleForm[key].match(/\d+\.?\d{0,2}/, "") === null
          ? ""
          : this.ruleForm[key].match(/\d+\.?\d{0,2}/, "")[0];
      /** 报价金额 */
      if (key == "offerPrice") {
        if (this.ruleForm[key].indexOf(".") < 0) {
          this.ruleForm[key] = this.ruleForm[key].substring(0, 5);
        } else {
          this.ruleForm[key] = this.ruleForm[key].substring(0, 8);
        }
      } else {
        if (this.ruleForm[key].indexOf(".") < 0) {
          this.ruleForm[key] = this.ruleForm[key].substring(0, 7);
        } else {
          this.ruleForm[key] = this.ruleForm[key].substring(0, 10);
        }
      }
    },
    radioChange(e) {
      let newNum =
        Number(this.num) *
        Number(this.gruopData.listingPrice) *
        (Number(this.templateSelection.payRatio) / 100);
      this.allPice = newNum;
    },
    getlisst() {
      tGroupDtetails(this.$route.query.goodsId).then(res => {
        console.log(res, "sdddddddddddddddddddddddddddddddd");
        if (res.code == 0) {
          console.log(res, "====================");
          // this.tableData = res.data.groupPremiumList;
          this.pageData = res.data.groupPriceList;
          this.TbaleList = res.data.groupEnterpriseList;
          this.gruopData = res.data;
        }
      });
    },
    getNewlist() {
      let config = {
        goodsId: this.$route.query.goodsId,
        page: 1,
        size: 9999,
      };
      tradeOfferpage(config).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          if (this.tableData.length) {
            this.tableData.forEach(item => {
              item.createTime = item.createTime.replace(/T/g, " ");
            });
          }
        }
      });
    },
    //收藏商品
    follow() {
      if (!this.beforhandle("personalCenter:auctionSale:partake:collect")) return;
      reqFollow({
        goodsId: this.$route.query.goodsId,
        type: 0,
      })
        .then(ret => {
          if (ret.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            // this.$refs.detail.getlisst(this.$route.query.goodsId);
            this.getlisst();
          } else {
            this.$message({
              type: "error",
              message: ret.message,
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //取消收藏
    follows() {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reqFollow({
            goodsId: this.$route.query.goodsId,
            type: 1,
          }).then(res => {
            if (res.code == 0) {
              // this.$refs.detail.getlisst(this.$route.query.goodsId);
              this.getlisst();
              this.$message({
                type: "success",
                message: "取消收藏成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.goodsdetail {
  width: 1200px;
  padding: 25px 20px;
  background: white;
  border: 1px solid #e5e5e5;
  margin: 15px auto;

  &::before,
  &::after {
    display: table;
    content: "";
  }
  .groupInformation {
    margin-top: 10px;
    border: 1px solid #ccc;
    padding: 25px 20px;
  }

  .titleInfo {
    font-size: 18px;
    font-weight: bold;
  }
  .tableMain {
    display: flex;
    flex-direction: row;
    .pirceTable {
      margin-top: 20px;
      width: 500px;

      .gear {
        display: flex;
        .pirce {
          font-size: 14px;
        }
      }
    }
    .border {
      width: 2px;
      background-color: #6666;
    }
    .tableRight {
      margin-left: 30px;
      margin-top: 20px;
      display: flex;
    }
  }

  .orderNumber {
    margin-top: 10px;
    border: 1px solid #ccc;
    .order {
      display: flex;
      padding: 10px 20px 10px 0;
      .join {
        margin-left: 10px;
        width: 150px;
        height: 50px;
        margin-top: -3px;
      }
      .collect {
        margin-left: 10px;
        width: 150px;
        height: 50px;
        margin-top: -3px;
      }
    }
  }
  .success {
    margin-top: 10px;
    border: 1px solid #ccc;
    padding: 20px;
  }
}
.company {
  margin: 20px 0;
  .company_list {
    border: 1px solid #ccc;
    padding: 0 20px;
    font-size: 18px;
    background: #e5e5e5;
    height: 45px;
    line-height: 45px;
    color: #000;
  }
}
.company_table {
  margin-top: 10px;
}
.details_bottom {
  margin-top: 20px;

  .regulation_bottom {
    // margin-left: 20px;
    width: 100%;
  }
}
.img_all {
  border: 1px solid #ccc;
  margin-top: 10px;
  padding: 10px;
}
.flex_item {
  margin-top: 10px;
}
.origin_item {
  color: aqua;
  cursor: pointer;
}
.iamg_y {
  text-align: center;
  img {
    width: 400px;
  }
}
.form {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.form-box {
  background: #f7f7f7;
  display: flex;
  // align-items: center;
  padding-top: 16px;
  position: relative;

  .el-input {
    width: 100px;
  }
  .lowestDiffPrice {
    position: absolute;
    left: 100px;
    color: red;
    bottom: 0px;
  }
}

.form-box {
  .btn-wrap {
    .el-button {
      border-radius: 0;
      padding: 0;
      height: 40px;
    }

    .follow {
      padding: 0 5px;
      border-radius: 4px;
      height: 40px;
    }

    .add {
      width: 160px;
      border-radius: 4px;
      height: 40px;
      margin-left: 30px;
      margin-bottom: 16px;
    }
  }
}
.offerPrice {
  &::v-deep .el-input__inner {
    height: 36px !important;
    border-radius: 0;
  }

  i {
    display: inline-flex;
    height: 35px;
    width: 35px;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    cursor: pointer;
  }

  span {
    display: inline-block;
    margin-left: 5px;
  }
}
.countdown {
  margin-right: 10px;
  text-align: center;
}
.subimt_btn {
  width: 20%;
  line-height: 30px;
  background: linear-gradient(90deg, #2079fb, #4cb2fc);
  color: #fff;
  font-size: 16px;
  text-align: center;
  border-radius: 2px;
  margin-top: 22px !important;
  margin-bottom: 60px;
}
.width_center {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  .go_0 {
    position: relative;
    top: 20px;
    left: 20px;
    text-align: center;
    line-height: 30px;
    width: 90px;
    height: 34px;
    border: 1px solid #d2d2d2;
    border-radius: 17px;
    font-size: 14px;
    cursor: pointer;
  }
}
::v-deep .articlContet {
  width: 70%;
  margin: 0 auto;
  img {
    display: block;
    margin: 0 auto;
  }
}
.img {
  min-height: 500px;
}
.title {
  padding-top: 29px;
  height: 60px;
  font-size: 30px;
  font-weight: 500;
  color: #000000;
  line-height: 35px;
  text-align: center;
}
.data {
  margin-top: 27px;
  height: 35px;
  line-height: 35px;
  background: #f8f8f8;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.content_all {
  margin: 20px auto;
  background: #f9f9f9;
  width: 70%;
  border: 1px dashed #d2d2d2;
  border-radius: 4px;
}
.fileListImg {
  // text-align: center;
  padding: 10px;
  display: flex;

  // justify-content: center;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}
</style>
